import config from '../config'
import query from '../api/BaseApi'

export default class survey {
  constructor() {
    this.host = config.movie_host;
    this.model = 'survey';
  }
  async query({ host = this.host, method, urlParams, bodyPayload, pathPrefix = '/api/v1/', model = this.model, path = '', headers = null }) {
    return await query({
      host: host,
      method: method,
      urlParams: urlParams,
      bodyPayload: bodyPayload,
      pathPrefix: pathPrefix,
      model: model,
      path: path,
      headers: headers,
    })
  }
  async getoffsetTags() {
    return await this.query({
      method: 'GET',
      path: "/offsets",
    })
  }
  async getCrowdTags() {
    return await this.query({
      method: 'GET',
      path: "/crowds",
    })
  }
  async getAllCrowdTags() {
    return await this.query({
      method: 'GET',
      path: "/crowds/all",
    })
  }
  async getSubCrowdTags(urlParams = { crowd: undefined }) {
    return await this.query({
      method: 'GET',
      path: "/crowds/sub",
      urlParams: urlParams
    })
  }
  async getBoxTags() {
    return await this.query({
      method: 'GET',
      path: "/boxes",
    })
  }

}